import { Box, Flex, Text } from '@chakra-ui/react';
import { faCircleCheck, faDownload } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@morressier/alembic';
import { useState } from 'react';
import { formatDate } from 'src/utils/date';
import { downloadFile } from 'src/utils/file';
import { useSubmissionData } from '../../../contexts/SubmissionDataProvider';

export const ICMJEDisclosureFormSubmitted: React.FC = () => {
  const { icmjeForm } = useSubmissionData();

  const icmjeFormSubmitted = icmjeForm?.[0];

  const DownloadButton = () => {
    const [isFileDownloading, setIsFileDownloading] = useState(false);

    const handleFileDownload = async (fileUrl: string) => {
      try {
        setIsFileDownloading(true); // disable button
        await downloadFile(fileUrl);
      } finally {
        setIsFileDownloading(false); // re-enable no matter what
      }
    };

    return (
      <Button
        onClick={() => {
          if (icmjeFormSubmitted?.file.url) {
            handleFileDownload(icmjeFormSubmitted.file.url);
          }
        }}
        leftIcon={<FontAwesomeIcon icon={faDownload} />}
        isDisabled={isFileDownloading || !icmjeFormSubmitted?.file?.url}
        isLoading={isFileDownloading}
        variant="secondary"
      >
        Download
      </Button>
    );
  };
  return (
    icmjeForm && (
      <Box>
        <Flex
          height="112px"
          width="100%"
          background="successSecondaryFill"
          justifyContent="center"
          alignItems="center"
          borderRadius="base"
          color="successPrimaryContentAccent"
          marginBottom={8}
        >
          <FontAwesomeIcon fontSize={40} icon={faCircleCheck} />
        </Flex>
        <Flex flexDirection="column" gap={2}>
          <Text textStyle="headingTitle">Forms and Disclosures Submitted</Text>
          <Text textStyle="textBody">
            Forms and Disclosures have been successfully submitted for all
            authors on {formatDate(new Date(icmjeFormSubmitted?.date ?? ''))}.
            You may download a copy of the submitted form(s) below.`
          </Text>
        </Flex>
        <Flex justifyContent="flex-start" mt={8}>
          <DownloadButton />
        </Flex>
      </Box>
    )
  );
};
